
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandAe as ObiOwnShipNoCommandAeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-ae.js';
 
 
 

 
 export const ObiOwnShipNoCommandAe = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-ae',
   elementClass: ObiOwnShipNoCommandAeElement,
   events: {
     
   }
  });
 
 